module.exports = __webpack_public_path__ + "media/images/guide-thumb-1t-ca27410f3323013970f403b019fd3ef8.png";